<div class="documentos-buscador">
	<div class="documentos-buscador__heading">
		<div>
			<strong>Agregar documentos a la liquidación</strong>
			<p>Busque y seleccione un documento del cliente para agregarlo al detalle.</p>
		</div>
		<ng-content select="[accionesDescripciones]"></ng-content>
	</div>
	<div class="documentos-buscador__controls">
		<ng-select class="documentos-buscador__select" [(ngModel)]="documentoBuscado"
			[ngModelOptions]="{ standalone: true }" [items]="searchCatalog"
			bindLabel="nombreTipoDte" [searchFn]="mostrarResultado"
			[loading]="searchLoading" [readonly]="!hayCliente"
			placeholder="Buscar documento por folio, tipo o razón social…"
			aria-label="Buscar documento del cliente para liquidación"
			(search)="searchItem($event)" (change)="seleccionarResultado($event)" (clear)="limpiarBusqueda()"
			notFoundText="Sin documentos coincidentes con los filtros del modal">
			<ng-template ng-option-tmp let-item="item">
				<strong>{{ item.nombreTipoDte }} · Folio {{ item.folio }}</strong>
				<small class="d-block text-muted">
					{{ item.fecha | date : 'dd/MM/yyyy' }} · {{ item.nombreSucursal }} ·
					{{ item.total | currency : '$ ' : 'symbol' : '1.0-0' : 'es' }}
				</small>
			</ng-template>
		</ng-select>
		<button type="button" class="btn btn-outline-primary" (click)="openDocumentsListModal()">
			<i class="flaticon-search"></i> Ver documentos
		</button>
	</div>
	<small class="d-block text-muted mt-2" *ngIf="!hayCliente">Seleccione primero un cliente.</small>
	<small class="d-block text-muted mt-2" *ngIf="hayCliente">Se aplican los filtros de la lista de documentos. Abra “Ver documentos” para cambiar el tipo o las fechas.</small>
	<small class="d-block text-danger mt-2" *ngIf="errorBusqueda" role="alert">No pudimos buscar documentos. Intente nuevamente.</small>
	<div class="documentos-buscador__separator"><span>o ingrese una línea manualmente</span></div>
</div>

<ng-template #listaBuscaDocumento let-d="dismiss">
	<div class="modal-header documentos-modal__header">
		<div>
			<h5 class="modal-title">Documentos disponibles</h5>
			<p class="text-muted mb-0 mt-2">Seleccione los documentos del cliente que desea incluir en esta liquidación.</p>
		</div>
		<button type="button" class="close" aria-label="Cerrar" (click)="d('cerrar')"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body documentos-modal__body">
		<section class="documentos-modal__filters" aria-label="Filtros de documentos">
			<div class="documentos-modal__section-title">Filtrar documentos</div>
			<app-search-bar class="documentos-modal-search"
				[criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal"
				[config]="configLocal.barraBusqueda"
				[filtroDTE]="true" [tipoDteInicialId]="tipoDteInicialId"
				[filtroEstadoSii]="true" [filtroEmisor]="false" [filtroEstadoDte]="true"
				[nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker"
				[insideModal]="true" [useAccordionMode]="false"
				(busqueda)="searchElementsByFilter($event)">
			</app-search-bar>
		</section>

		<div class="documentos-modal__toolbar">
			<span class="text-muted">Seleccione documentos de un mismo tipo. Puede continuar seleccionando en otras páginas.</span>
			<label class="documentos-modal__page-size" for="documentos-por-pagina">
				Mostrar
				<select id="documentos-por-pagina" class="form-control form-control-sm"
					[ngModel]="pageDocuments.pageSize" (ngModelChange)="cambiarTamanoPagina($event)" [disabled]="consultandoDocumento">
					<option [ngValue]="10">10</option>
					<option [ngValue]="25">25</option>
					<option [ngValue]="50">50</option>
				</select>
				por página
			</label>
		</div>

		<div class="documentos-modal__table table-responsive" [attr.aria-busy]="consultandoDocumento">
			<table class="table table-hover mb-0">
				<thead>
					<tr>
						<th class="documentos-modal__check">
							<input #seleccionPagina type="checkbox" aria-label="Seleccionar todos los documentos de esta página"
								[checked]="todosSeleccionadosEnPagina" [indeterminate]="seleccionParcialEnPagina"
								[disabled]="consultandoDocumento || !documentRows.length"
								(change)="selectAll(seleccionPagina.checked)" />
						</th>
						<th scope="col">Tipo de documento</th>
						<th scope="col">Folio</th>
						<th scope="col">Fecha de emisión</th>
						<th scope="col">Sucursal</th>
						<th scope="col" class="text-right">Monto</th>
					</tr>
				</thead>
				<tbody *ngIf="!consultandoDocumento">
					<tr *ngFor="let documento of documentRows" [class.documentos-modal__selected]="estaSeleccionado(documento)">
						<td class="documentos-modal__check">
							<input #seleccionDocumento type="checkbox" [attr.aria-label]="'Seleccionar documento folio ' + documento.folio"
								[checked]="estaSeleccionado(documento)"
								(change)="seleccionarDocumento(documento, seleccionDocumento.checked)" />
						</td>
						<td>{{ documento.nombreTipoDte }}</td>
						<td class="text-nowrap">{{ documento.folio }}</td>
						<td class="text-nowrap">{{ documento.fecha | date : 'dd/MM/yyyy' }}</td>
						<td>{{ documento.nombreSucursal }}</td>
						<td class="text-right text-nowrap font-weight-bold">{{ documento.total | currency : '$ ' : 'symbol' : '1.0-0' : 'es' }}</td>
					</tr>
					<tr *ngIf="!documentRows.length">
						<td colspan="6" class="documentos-modal__empty" role="status">
							<ng-container *ngIf="!errorDocumentos; else errorCarga">
								<strong>No hay documentos para estos filtros.</strong>
								<p class="mb-0 mt-2">Pruebe con otro tipo de documento o rango de fechas.</p>
							</ng-container>
							<ng-template #errorCarga>
								<strong>No pudimos cargar los documentos.</strong>
								<button type="button" class="btn btn-link" (click)="setPageDocuments({ offset: 0 })">Reintentar</button>
							</ng-template>
						</td>
					</tr>
				</tbody>
				<tbody *ngIf="consultandoDocumento">
					<tr><td colspan="6" class="documentos-modal__empty" role="status">
						<span class="spinner-border spinner-border-sm text-primary mr-2" aria-hidden="true"></span>Cargando documentos…
					</td></tr>
				</tbody>
			</table>
		</div>

		<div class="documentos-modal__pagination">
			<span class="text-muted" aria-live="polite">{{ primerDocumento }}–{{ ultimoDocumento }} de {{ pageDocuments.totalElements }} documentos</span>
			<ngb-pagination [collectionSize]="pageDocuments.totalElements" [page]="pageDocuments.pageNumber + 1"
				[pageSize]="pageDocuments.pageSize" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"
				[disabled]="consultandoDocumento" size="sm"
				(pageChange)="setPageDocuments({ offset: $event - 1 })" aria-label="Páginas de documentos">
			</ngb-pagination>
		</div>
	</div>

	<div class="modal-footer documentos-modal__footer">
		<div class="documentos-modal__selection" aria-live="polite">
			<strong>{{ selectedDocuments.length }} seleccionados</strong>
			<span class="text-muted">Total: {{ totalSeleccionado | currency : '$ ' : 'symbol' : '1.0-0' : 'es' }}</span>
		</div>
		<div class="documentos-modal__actions">
			<button type="button" class="btn btn-light" (click)="d('cerrar')">Cerrar</button>
			<button type="button" class="btn btn-primary" [disabled]="consultandoDocumento || !selectedDocuments.length"
				(click)="procesarDocumentsADetalles()">Agregar seleccionados</button>
		</div>
	</div>
</ng-template>
